import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import { CheckActionPermission } from "Actions/commonAction";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import { FormatColorResetOutlined } from "@material-ui/icons";
import Add from "@material-ui/icons/Add";
import { instance } from "Actions/AxiosInstance";
import addIcon from "Assets/newicons/action/add-round/glyph/add-round-filled-blue-16px.svg";
import deleteIcon from "Assets/newicons/action/delete-bin/outline/delete-bin-outline-16px.svg";
import EditIcon from "Assets/newicons/action/edit/outline/edit-outline-16px.svg";
import checkRoundGreen from "Assets/newicons/notify/check-round/glyph/check-round-outline-green-16px.svg";
import DynamicForm from "Component/DynamicForm";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import headersList from "Constants/headersList";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

// function getAccess(access) {
//   if (access) {
//     const checkLocObject = access.find(
//       (access1) => access1.applicablefortypeid == 3,
//     );
//     if (!checkLocObject) {
//       const object = access[0];
//       const locationObj = {
//         compensatoraccessid: 0,
//         applicablefortypeid: 3,
//         applicableforids: formatArrayOrSplitString(
//           object && object.locationids && object.locationids,
//         ),
//         locationids: null,
//       };
//       const allAccess = access.map((x) => ({
//         ...x,
//         locationids: null,
//       }));
//       allAccess.push(locationObj);
//       return allAccess;
//     }
//     return access;
//   }
//   return [];
// }
// let globalcomps = [];

class CandidateSource extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      postData: [],
      customData: [],
      customSourcetype: [],
      permissions: { editable: true, readonly: true },
      isedit: false,
      //     candidatesourcecategoryid: null,
      // candidatesourcetypeid: null,
      // categoryname: null,
      // iscustom: false,
      // sourcetypename: null,
      // subcandidatesourcecategoryid: null,
      // subcandidatesourcetypeid: null,
      ischecked: false,
      sourcetypename: "",
      categoryname: "",
      tempCandidateSourceType: "",
      tempcategoryname: null,
      empList: [],
      iscustomtypeerror: false,
      isedit1: false,
      SelectedEmpData: null,
      expensecompensatorid: null,
      compensatorList: [],
      defaultSourcetype: [],
      selectedBusinessUnit: null,
      dropdown: false,
      selectedCompensator: null,
      defaultSourceTypes: [{ displayvalue: "1", displayname: "Naukri" }],
      customtypename: "",
      sourcename: "",
    };
    this.handleBlur = this.handleBlur.bind(this);
    this.handleBlur1 = this.handleBlur1.bind(this);
    this.setischecked = this.setischecked.bind(this);
    this.GetCandidateSourceData = this.GetCandidateSourceData.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onDeleteSubCandidateSourceType =
      this.onDeleteSubCandidateSourceType.bind(this);
    this.setCandidateSource = this.setCandidateSource.bind(this);
    this.addSource = this.addSource.bind(this);
    this.confirmDelete = this.confirmDelete.bind(this);
    this.updatePostData = this.updatePostData.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.onEdit1 = this.onEdit1.bind(this);
  }

  setischecked() {
    this.setState({ ischecked: !this.state.ischecked });
  }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("candidateSources");
    if (isTrue) {
      this.setState({ permissions }, () => {
        this.GetCandidateSourceData();
      });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  GetCandidateSourceData() {
    instance
      .get("recruit/getallcandidatesource/1")
      .then((result) => {
        this.setState({
          postData: result.data.result,
          customData:
            this.state.customData.length == 0
              ? this.state.sourcetypeid
                ? result.data.result.find(
                    (x) =>
                      x.subcandidatesourcecategoryid == this.state.sourcetypeid,
                  )
                : result.data.result[0]
              : result.data.result.find(
                  (x) =>
                    x.subcandidatesourcecategoryid ==
                    this.state.customData.subcandidatesourcecategoryid,
                ) || [],
          defaultSourcetype:
            this.state.customData.length == 0
              ? this.state.sourcetypeid
                ? []
                : result.data.result[0].candidatesourcetype.filter(
                    (x) => x.iscustom == false,
                  )
              : result.data.result.find(
                  (x) =>
                    x.subcandidatesourcecategoryid ==
                    this.state.customData.subcandidatesourcecategoryid,
                )
              ? result.data.result
                  .find(
                    (x) =>
                      x.subcandidatesourcecategoryid ==
                      this.state.customData.subcandidatesourcecategoryid,
                  )
                  .candidatesourcetype.filter((x) => x.iscustom == false)
              : [],
          customSourcetype:
            this.state.customData.length == 0
              ? this.state.sourcetypeid
                ? []
                : result.data.result[0].candidatesourcetype.filter(
                    (x) => x.iscustom == true,
                  )
              : result.data.result.find(
                  (x) =>
                    x.subcandidatesourcecategoryid ==
                    this.state.customData.subcandidatesourcecategoryid,
                )
              ? result.data.result
                  .find(
                    (x) =>
                      x.subcandidatesourcecategoryid ==
                      this.state.customData.subcandidatesourcecategoryid,
                  )
                  .candidatesourcetype.filter((x) => x.iscustom == true)
              : [],
          sourcetypeid: null,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  addSource() {
    this.setState({
      customData: [],
      dropdown: true,
      selectedCompensator: null,
      SelectedEmpData: null,
      allbu: false,
      alldep: false,
      allloc: false,
    });
  }

  setCandidateSource(Data) {
    this.setState({
      dropdown: false,
      customData: Data,
      defaultSourcetype:
        Data &&
        Data.candidatesourcetype &&
        Data.candidatesourcetype.filter((x) => x.iscustom == false),
      customSourcetype:
        Data &&
        Data.candidatesourcetype &&
        Data.candidatesourcetype.filter((x) => x.iscustom == true),
    });
  }

  updatePostData(key, value) {
    if (key == "sourcetypename" && value == " ") {
      // this.setState({ iscustomtypeerror: true });
      this.props.enqueueSnackbar("Please add custom type", {
        variant: "error",
      });
    } else if (key == "sourcetypename" && /\s/g.test(value)) {
      this.props.enqueueSnackbar("Source name can't have space", {
        variant: "error",
      });
      return;
    } else {
      this.setState({ [key]: value, isedit: true });
    }

    // this.setState({ [key]: value, isedit: true });
  }

  handleBlur(key, value, flag = false) {
    const { tempcategoryname } = this.state;
    if (value) {
      instance
        .post("recruit/configcandidatesourcecategory", {
          iscustom: true,
          categoryname: value,
          candidatesourcecategoryid:
            (tempcategoryname && tempcategoryname.candidatesourcecategoryid) ||
            null,
          subcandidatesourcecategoryid:
            (tempcategoryname &&
              tempcategoryname.subcandidatesourcecategoryid) ||
            null,
        })
        .then((res) => {
          this.setState({
            categoryname: "",
            tempcategoryname: null,
            dropdown: false,
            customData: [],
            sourcetypeid: res.data.result[0].sourcetypeid,
          });
          this.GetCandidateSourceData();
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  handleBlur1(key, value) {
    const { tempCandidateSourceType, customData } = this.state;
    if (value) {
      instance
        .post("recruit/configcandidatesourcetype", {
          subcandidatesourcetypeid:
            (tempCandidateSourceType &&
              tempCandidateSourceType.subcandidatesourcetypeid) ||
            null,
          subcandidatesourcecategoryid: customData.subcandidatesourcecategoryid,
          candidatesourcetypeid: null,
          sourcetypename: value,
          iscustom: true,
        })
        .then((result) => {
          this.setState({
            sourcetypename: "",
            tempCandidateSourceType: "",
            isedit: false,
          });
          this.GetCandidateSourceData();
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  onDeleteSubCandidateSourceType(id) {
    instance
      .post(`recruit/deletesourcetype`, { subcandidatesourcetypeid: id })
      .then(() => {
        this.props.enqueueSnackbar("deleted successfully", {
          variant: "success",
        });
        this.GetCandidateSourceData();
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  onEdit(item) {
    this.setState({
      isedit: true,
      tempCandidateSourceType: item,
      sourcetypename: item.sourcetypename,
    });
  }

  onEdit1(item) {
    const { customData } = this.state;
    // customData.subcandidatesourcecategoryid = item.subcandidatesourcecategoryid;
    this.setState({
      isedit1: true,
      tempcategoryname: item,
      categoryname: item.categoryname,
      dropdown: true,
      // subcandidatesourcecategoryid: item.subcandidatesourcecategoryid,
    });
  }

  onDelete(id) {
    instance
      .post(`recruit/deletesourcecategory`, {
        subcandidatesourcecategoryid: id,
      })
      .then(() => {
        this.props.enqueueSnackbar("deleted successfully", {
          variant: "success",
        });
        this.setState(
          {
            customData: [],
          },
          () => this.GetCandidateSourceData(),
        );
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  confirmDelete(id, isSubcatory = false) {
    this.props.enqueueSnackbar("Are you sure you want to delete?", {
      variant: "warning",
      action: [
        <Button
          key="1"
          color="inherit"
          size="small"
          onClick={() => {
            this.props.closeSnackbar();
            isSubcatory
              ? this.onDelete(id)
              : this.onDeleteSubCandidateSourceType(id);
          }}
        >
          Yes
        </Button>,
        <Button
          key="2"
          color="inherit"
          size="small"
          onClick={() => this.props.closeSnackbar()}
        >
          No
        </Button>,
      ],
    });
  }

  render() {
    const {
      selectedCompensator,
      postData,
      customData,
      customSourcetype,
      defaultSourcetype,
      sourcetypename,
      categoryname,
    } = this.state;

    return (
      <div className="content-outer-wrapper">
        <Helmet>
          <title>{headersList.Config.ATS.CandidateSources.header}</title>
        </Helmet>
        {this.state.permissiondenied ? (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        ) : (
          <Grid container className="expense-outer">
            <Grid item xs={12} md={12} sm={12}>
              <div>
                <span className="page-header-name">Candidate source</span>
              </div>
            </Grid>
            <Grid item xs={12} md={12} sm={12}>
              <Grid container>
                <Grid
                  item
                  xs={12}
                  md={3}
                  sm={12}
                  style={{ position: "relative", left: 1, zIndex: 1 }}
                >
                  <div>
                    <div>
                      {this.state.postData &&
                        this.state.postData.map((item, index) => (
                          <div
                            key={index}
                            className={
                              customData.subcandidatesourcecategoryid ==
                              item.subcandidatesourcecategoryid
                                ? "selected-div1 display-flex"
                                : "display-flex"
                            }
                            style={{
                              height: 40,
                              alignItems: "center",
                              boxSizing: "border-box",
                            }}
                          >
                            <div
                              className="compensator-name"
                              onClick={() => this.setCandidateSource(item)}
                              style={{ color: "#010709" }}
                            >
                              {item.categoryname}
                            </div>
                            {!item.candidatesourcecategoryid && (
                              <div>
                                {this.state.permissions.editable && (
                                  <img
                                    onClick={() => this.onEdit1(item)}
                                    src={EditIcon}
                                    className="vertical-middle cursor-pointer"
                                  ></img>
                                )}
                                {this.state.permissions.editable && (
                                  <img
                                    onClick={() =>
                                      this.confirmDelete(
                                        item.subcandidatesourcecategoryid,
                                        true,
                                      )
                                    }
                                    src={deleteIcon}
                                    className="vertical-middle cursor-pointer"
                                    style={{ paddingLeft: 8 }}
                                  ></img>
                                )}
                              </div>
                            )}
                          </div>
                        ))}
                    </div>
                    {this.state.dropdown && (
                      <div
                        className="selected-div1 position-abs"
                        style={{
                          display: "flex",
                          position: "relative",
                          bottom: 0,
                          left: 0,
                          width: "calc(100% - 48px)",
                          // padding: "8px 24px",
                        }}
                        // className=""
                        // style={{

                        // }}
                      >
                        <TextField
                          className="margin-top-0 width100 margin-bottom-0"
                          margin="normal"
                          value={categoryname}
                          variant="outlined"
                          onChange={(e) =>
                            this.updatePostData("categoryname", e.target.value)
                          }
                          onBlur={(e) => {
                            this.handleBlur(
                              "categoryname",
                              e.target.value,
                              true,
                            );
                          }}
                          autoComplete="off"
                          placeholder="Add category"
                        />

                        {/* {this.state.isedit1 == true ? (
                        <img
                          src={checkRoundGreen}
                          style={{
                            position: "absolute",
                            right: 16,
                            bottom: 11,
                          }}
                          onClick={(e) =>
                            this.handleBlur("categoryname", e.target.value)
                          }
                        ></img>
                      ) : (
                        ""
                      )} */}
                        <div
                          style={{ position: "absolute", right: 16, top: 14 }}
                          // onClick={() => {
                          //   this.handleBlur1("sourcetypename", sourcetypename);
                          // }}
                        >
                          {this.state.isedit ? (
                            <img src={checkRoundGreen}></img>
                          ) : (
                            <img src={addIcon}></img>
                          )}
                        </div>
                      </div>
                    )}
                    {this.state.permissions.editable && (
                      <div
                        className="margin-top-10 cursor-pointer clear-both"
                        onClick={this.addSource}
                      >
                        <Add
                          style={{
                            height: 16,
                            width: 16,
                            marginLeft: 8,
                            marginRight: 16,
                            position: "relative",
                            top: 3,
                            borderRadius: 16,
                            background: "#1e8ced",
                            color: "#fff",
                          }}
                        />
                        <span style={{ color: "#1e8ced", fontSize: 14 }}>
                          Add category
                        </span>
                      </div>
                    )}
                  </div>
                </Grid>
                <Grid
                  item
                  md={4}
                  sm={12}
                  className="position-rel"
                  style={{
                    zIndex: 0,
                    width: 304,
                    borderRadius: 4,
                    padding: "8px 24px 8px 24px",
                    border: "solid 1px #d9dadb",
                    height: "calc(100vh - 150px)",
                  }}
                >
                  <div
                    className="expense-types"
                    style={{
                      width: "calc(100% + 8px)",
                      paddingRight: 8,
                      maxHeight: "86%",
                    }}
                  >
                    {this.state.defaultSourcetype &&
                      this.state.defaultSourcetype.length > 0 && (
                        <div className="default-expense-types">
                          <div>
                            <div className="custom-divider"></div>
                            <div className="type-heading">Default types</div>
                          </div>
                          <List className="default-expense-types-list">
                            {this.state.defaultSourcetype &&
                              this.state.defaultSourcetype.map((type) => (
                                <ListItem className="default-expense-types-list-item">
                                  {type.sourcetypename}
                                </ListItem>
                              ))}
                          </List>
                        </div>
                      )}
                    <div className="custom-expense-types">
                      <div>
                        <div className="custom-divider"></div>
                        <div className="type-heading">Custom types</div>
                      </div>
                      <List className="custom-expense-types-list padding-bottom-0">
                        {/* Glassdoor */}
                        {this.state.customSourcetype &&
                          this.state.customSourcetype.map((type, index) => (
                            <ListItem
                              className="default-expense-types-list-item"
                              // style={{ paddingTop: 4, paddingBottom: 4 }}
                            >
                              {type.sourcetypename}
                              {this.state.permissions.editable && (
                                <ListItemSecondaryAction style={{ right: 0 }}>
                                  <img
                                    onClick={() => this.onEdit(type)}
                                    src={EditIcon}
                                    className="vertical-middle cursor-pointer"
                                  ></img>
                                  <img
                                    onClick={() =>
                                      this.confirmDelete(
                                        type.subcandidatesourcetypeid,
                                      )
                                    }
                                    src={deleteIcon}
                                    className="vertical-middle cursor-pointer"
                                    style={{ paddingLeft: 8 }}
                                  ></img>
                                </ListItemSecondaryAction>
                              )}
                            </ListItem>
                          ))}
                      </List>
                    </div>
                  </div>
                  {this.state.permissions.editable && (
                    <div
                      className="position-abs"
                      style={{
                        bottom: 0,
                        left: 0,
                        width: "calc(100% - 48px)",
                        padding: "8px 24px",
                      }}
                    >
                      <DynamicForm
                        fields={textinputconverter({
                          value: sourcetypename,
                          label: "",
                          placeholder: "Add custom type",
                        })}
                        onChange={(value) =>
                          this.updatePostData("sourcetypename", value)
                        }
                        onBlur={() => {
                          this.handleBlur1("sourcetypename", sourcetypename);
                        }}
                        className="abcd"
                      />
                      <div
                        style={{ position: "absolute", right: 36, top: 22 }}
                        // onClick={() => {
                        //   this.handleBlur1("sourcetypename", sourcetypename);
                        // }}
                      >
                        {this.state.isedit ? (
                          <img src={checkRoundGreen}></img>
                        ) : (
                          <img src={addIcon}></img>
                        )}
                      </div>
                      {this.state.iscustomtypeerror && <div>pls add type</div>}
                    </div>
                  )}
                </Grid>
              </Grid>
            </Grid>
            {/* <Grid item xs={12} md={12} sm={12}>
            <Button
              color="primary"
              variant="contained"
              style={{ width: 140 }}
              onClick={this.onSave}
            >
              Save
            </Button>
          </Grid> */}
          </Grid>
        )}
      </div>
    );
  }
}

CandidateSource.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  SubscriptionData: state.SubscriptionInfo.SubscriptionData,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles()(withSnackbar(CandidateSource)));
